import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes dudaba en cada paso… ahora sé qué hacer incluso bajo presión.',
  name: 'Valeria M.',
  role: 'Enfermera'
}, {
  quote: 'Me dio claridad mental. Ya no me quedo paralizada cuando pasan muchas cosas al mismo tiempo.',
  name: 'Camila R.',
  role: 'Estudiante'
}, {
  quote: 'No es teoría… es un sistema que realmente se usa en guardia.',
  name: 'Daniela S.',
  role: 'Enfermera clínica'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-12 px-5" data-id="element-273">
      <div className="max-w-xl mx-auto" data-id="element-274">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-275">
          💬 ¿Qué dicen quienes ya usan el sistema?
        </h2>

        <div className="space-y-4" data-id="element-276">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-277">
              <div className="flex gap-0.5 mb-3" data-id="element-278">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-279" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-280">
                "{t.quote}"
              </p>
              <div data-id="element-281">
                <p className="font-bold text-white text-sm" data-id="element-282">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-283">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}